module.exports = __webpack_public_path__ + "static/media/team-max.3de8232f.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/team-max.jpg
 ** module id = 449
 ** module chunks = 0
 **/